module.exports = ol.Map;